export const availableLanguages = ['en', 'fr', 'de', 'it'];

let orgPrefix = '';
let teamType = '';
let region = '';
let mod = '';

export const setOrgPrefix = (prefix) => {
  orgPrefix = prefix;
};

export const setTranslationTeamType = (type) => {
  teamType = type;
};

export const setRegion = (reg) => {
  region = reg;
};

export const setMod = (newMod) => {
  mod = newMod;
};

export const fetchCorrectTranslation = (translation) => {
  if (
    mod &&
    translation?.[`${region}_${mod}`] !== undefined &&
    !translation?.[`${region}_${mod}`]
  ) {
    return null;
  }

  if (translation?.[region] !== undefined && !translation?.[region]) {
    return null;
  }

  if (
    mod &&
    translation?.[`${orgPrefix}_${mod}`] !== undefined &&
    !translation?.[`${orgPrefix}_${mod}`]
  ) {
    return null;
  }

  if (translation?.[orgPrefix] !== undefined && !translation?.[orgPrefix]) {
    return null;
  }

  if (mod && translation?.[`default_${mod}`] !== undefined && !translation?.[`default_${mod}`]) {
    return null;
  }

  return translation?.[`${region}_${mod}`]
    ? translation?.[`${region}_${mod}`]
    : translation?.[region]
    ? translation?.[region]
    : translation?.[`${orgPrefix}_${mod}`]
    ? translation?.[`${orgPrefix}_${mod}`]
    : translation?.[orgPrefix]
    ? translation?.[orgPrefix]
    : translation?.[`default_${mod}`]
    ? translation?.[`default_${mod}`]
    : translation?.default;
};

export const getTranslation = (
  t,
  key,
  array = false,
  index = 0,
  subKey = '',
  returnObject = false,
  params = {}
) => {
  let translation = t(`${teamType}.${key}`, {
    returnObjects: true,
    ...params
  });

  if (returnObject) return translation;

  if (array) translation = translation?.[index]?.[subKey] ?? translation?.[index];

  const returningTranslation = fetchCorrectTranslation(translation);

  if (returningTranslation === null) return null;

  return returningTranslation && returningTranslation !== ''
    ? returningTranslation
    : `${teamType}.${key}`?.toString();
};
